import styled from 'styled-components'
import { Form, Card as AntCard, Input, Button as AntButton, message } from 'antd'
import { useMutation } from '@apollo/client'
import { Link } from 'react-router-dom'

import { RESET_PASSWORD } from '../gqls'

const requiredRule = {
    required: true,
    message: 'Обязательное поле'
}

const emailRule = {
    type: 'email',
    message: 'Введите правильный электронный адрес'
}

const Card = styled(AntCard)`
    width: 400px;

    @media only screen and (max-width: 420px) {
        width: 95%;
    }
`
const Button = styled(AntButton)``

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100vh;

    @media only screen and (max-width: 420px) {
        justify-content: flex-start;
        padding-top: 30px;
    }
`
const Actions = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-top: 5px;
`

const Login = () => {

    const [resetPass, { loading }] = useMutation(RESET_PASSWORD, {
        onCompleted: () => {
            message.success("Сообщение отправлено на указанную почту")
        }
    })

    const handleSubmitForm = ({ email }) => {
        resetPass({
            variables: {
                where: {
                    email,
                }
            }
        })
    }

    return (
        <Wrapper>
            <Card title="Вход в панель администратора">
                <Form onFinish={handleSubmitForm} layout="vertical" name="login-from">
                    <Form.Item
                        colon={false}
                        label="Эл. почта"
                        name="email"
                        rules={[requiredRule, emailRule]}
                    >
                        <Input placeholder="Введите электронную почту..." />
                    </Form.Item>
                    <Actions>
                        <Button loading={loading} type="primary" htmlType="submit">
                            Сбросить
                        </Button>
                        <Link to={`/login`}>Войти</Link>
                    </Actions>
                </Form>
            </Card>
        </Wrapper>
    )
}

export default Login